import {
  createPOSDomainRegistry,
} from "../../engines/POSDomainRegistry";

import {
  createPOSActivityDomainResolver,
} from "../../engines/POSActivityDomainResolver";

import {
  createRetailPOSDomainComposition,
} from "./retailPOSDomainComposition";

import {
  createRetailPOSPublicationComposition,
} from "./retailPOSPublicationComposition";


/**
 * Retail POS Application Composition.
 *
 * Application-level composition root between the certified
 * Retail publication boundary, the generic POS domain
 * framework and the Retail runtime boundary.
 *
 * This factory is deliberately route-agnostic.
 *
 * It does NOT:
 *
 * - read React Router;
 * - resolve companyUuid;
 * - resolve activityUuid;
 * - own publication data;
 * - own Product data;
 * - own Session data;
 * - create a parallel POS resolver;
 * - create a parallel publication engine;
 * - create a repository;
 * - own React state.
 */
export function createRetailPOSApplicationComposition({
  publicationEngine,
  getVersion,

  listDocuments = null,
  resolveStudioReference = null,
  createDescriptorId,

  catalogProvider = null,
  sessionBridge = null,

  productResolver = null,
  productSearchProvider = null,

  workspaceComponent = null,
  dispose = null,
} = {}) {
  const publicationComposition =
    createRetailPOSPublicationComposition({
      publicationEngine,
      getVersion,

      listDocuments,
      resolveStudioReference,

      ...(createDescriptorId
        ? {
            createDescriptorId,
          }
        : {}),
    });

  const domainComposition =
    createRetailPOSDomainComposition({
      catalogProvider,
      sessionBridge,

      productResolver,
      productSearchProvider,

      workspaceComponent,
      dispose,
    });

  const posDomainRegistry =
    createPOSDomainRegistry({
      adapters: [
        domainComposition.domainAdapter,
      ],
    });

  const posActivityDomainResolver =
    createPOSActivityDomainResolver({
      posDomainRegistry,

      publicationRuntimeBridge:
        publicationComposition
          .publicationRuntimeBridge,
    });

  return Object.freeze({
    publicationComposition,
    domainComposition,

    activePublicationResolver:
      publicationComposition
        .activePublicationResolver,

    publicationRuntimeBridge:
      publicationComposition
        .publicationRuntimeBridge,

    posDomainRegistry,
    posActivityDomainResolver,

    domainAdapter:
      domainComposition.domainAdapter,

    workspaceComponent:
      domainComposition.workspaceComponent,
  });
}


export default
  createRetailPOSApplicationComposition;
